<payment-button [referenceNumber]="referenceNumber" *ngIf="referenceNumber"></payment-button>
